const messages = {
  step3: {
    actionBtn: "Logi sisse",
  },
};

export default {
  messages,
};
